class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    // Sneakly: przerwij ewentualne trwajace zamykanie (szybkie re-otwarcie)
    if (this.closeTimer) {
      clearTimeout(this.closeTimer);
      this.closeTimer = null;
    }
    this.detailsContainer.classList.remove('modal-closing');
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');

    // Sneakly: faza wyjscia - stock Dawn zdejmowal `open` od razu, wiec modal
    // znikal bez animacji. Klasa .modal-closing odpala animacje w CSS, timer
    // (NIE animationend - dziala tez przy prefers-reduced-motion i w podgladach
    // z zamrozonym zegarem animacji) faktycznie zamyka details po jej czasie.
    if (!this.detailsContainer.hasAttribute('open') || this.closeTimer) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      this.detailsContainer.removeAttribute('open');
      return;
    }
    this.detailsContainer.classList.add('modal-closing');
    this.closeTimer = setTimeout(() => {
      this.closeTimer = null;
      this.detailsContainer.classList.remove('modal-closing');
      this.detailsContainer.removeAttribute('open');
    }, 190);
  }
}

customElements.define('details-modal', DetailsModal);
